import {Injectable} from "@angular/core";
import {CartConnector} from "@spartacus/cart/base/core";
import { Cart } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import {GonvarriCartAdapter} from "../adapters/gonvarri-cart.adapter";

@Injectable({
  providedIn: 'root',
})
export class GonvarriCartConnector extends CartConnector {

  constructor(override adapter: GonvarriCartAdapter) {
    super(adapter);
  }

  public override save(
    userId: string,
    cartId: string,
    saveCartName?: string,
    saveCartDescription?: string,
    cloneCart?: boolean,
  ): Observable<Cart> {
    return this.adapter.saveAndClone(userId, cartId, saveCartName as string, saveCartDescription as string, cloneCart as boolean);
  }

}
